import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const CarouselSection_9_16_ImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '9_16_540', width: 540, height: 962, ratio: 0.56 },
];
